module.exports = __webpack_public_path__ + "img/bg_patrol_01.67960301.jpg";